/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module Angular-Core
 */

import { isUndefined } from 'underscore';
import { IAviDropdownOption } from 'standalone-components/avi-dropdown';
import { IEnumValue } from 'ajs/modules/core/services/schema-service';

/**
 * Returns a dropdown option used in the AviDropdownComponent.
 */
export function createDropdownOption(
    value: IAviDropdownOption['value'],
    label?: string,
    tooltip?: string,
): IAviDropdownOption {
    if (isUndefined(value)) {
        throw new Error('Dropdown option must have a value');
    }

    const parsedLabel = isUndefined(label) ? value.toString() : label;
    const parsedTooltip = isUndefined(tooltip) ? parsedLabel : tooltip;

    return {
        value,
        label: parsedLabel,
        tooltip: parsedTooltip,
    };
}

/**
 * Returns dropdown options given a list of EnumValues.
 */
export function createOptionsFromEnumProps(values: IEnumValue[] = []): IAviDropdownOption[] {
    return values.map(({ value, label, description }) => {
        return createDropdownOption(value, label, description);
    });
}
